export default __webpack_public_path__ + "static/media/saturn_symbol.1a7cdc4a.png";